import { navigate } from "@reach/router";
import { forceLogin, unAuthorize } from "./../../firebase";

export var isContinued;

export var Auth_ERRORS = {
  UN_AUTHORIZED: {
    errorTitle: "Unauthorized access",
    errorDesc:
      "You haven't logged in correctly or your session may have timed out. Please login again.",
    authorized: false,
    actions: [
      {
        name: "Login",
        action: () => {
          unAuthorize(); // signout from firebase..but without changing database data
          navigate("/");
        }
      }
    ]
  },
  ALREADY_LOGER_IN: {
    errorTitle: "You have already logged in elsewhere",
    errorDesc:
      "It appears that you may have already logged in, using another device. Choose 'Force Login' to log out of all other devices and continue watching here.",
    authorized: false,
    actions: [
      {
        name: "Cancel",
        action: () => {
          isContinued = false;
          unAuthorize();
          navigate("/");
        }
      },
      {
        name: "Force Login",
        action: () => {
          isContinued = true;
          forceLogin();
          navigate("/main");
        }
      }
    ]
  },
  SUSPECT: {
    errorTitle: "Your account is being accessed",
    errorDesc:
      "Your account is being accessed on another device; please use only one device at a time to access the account. Reset your password if you think your account has been compromised.",
    authorized: false,
    actions: [
      {
        name: "Login",
        action: () => {
          unAuthorize();
          navigate("/");
        }
      }
    ]
  }
};



// WEBPACK FOOTER //
// ./src/redux/middleware/constants.js